import { render } from "./NotFound.vue?vue&type=template&id=0e92365d"
const script = {}

import exportComponent from "H:\\Crossword\\capp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__